export default "__VITE_ASSET__3d019a89__"